import { render, staticRenderFns } from "./elevatorInfo.vue?vue&type=template&id=5ed6bb18&scoped=true&"
import script from "./elevatorInfo.vue?vue&type=script&lang=js&"
export * from "./elevatorInfo.vue?vue&type=script&lang=js&"
import style0 from "./elevatorInfo.vue?vue&type=style&index=0&id=5ed6bb18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6bb18",
  null
  
)

export default component.exports